import React from "react";

const About = () => (
  <section id="about" className="py-24 bg-gray-900">
    <div className="max-w-4xl mx-auto px-6 text-center">
      <h2 className="text-3xl md:text-4xl font-serif font-bold text-gold mb-8">
        About Senshoha Systems
      </h2>
      <p className="text-lg text-gray-300 leading-relaxed">
        Founded by CEO Reshan Athalsha, Senshoha Systems is redefining luxury
        home automation. Our unified IoT platform orchestrates door security,
        pool safety, and smart-glass privacy in one seamless experience,
        delivering unparalleled peace of mind.
      </p>
    </div>
  </section>
);

export default About;
